var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#016fd0;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216,306H396V486H216V306",
    transform: "translate(-216 -306)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.2,457.52V393l114.8.1v17.82l-13.27,14.18L396,439.43v18.19H374.82L363.56,445.2l-11.18,12.47-71.18-.15",
    transform: "translate(-216 -306)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.87,450.45V400.12h42.68v11.59H302.69v7.87h28.17V431H302.69v7.73h28.86v11.74H288.87",
    transform: "translate(-216 -306)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.34,450.45,355,425.25l-23.61-25.13h18.27L364,416.07l14.47-15.95H396v.4l-23.11,24.73L396,449.73v.72H378.33l-14.68-16.11-14.54,16.11H331.34",
    transform: "translate(-216 -306)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.56,335.77h27.67L324,357.84V335.77h34.16L364,352.31l5.91-16.54H396v64.5H258.14l28.42-64.5",
    transform: "translate(-216 -306)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.8,342.78l-22.33,50.29h15.32L289,383h22.82L316,393.07h15.69l-22.24-50.29Zm1.92,28.93,6.69-16,6.7,16Z",
    transform: "translate(-216 -306)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.52,393.06V342.77l21.53.08,11.08,30.91,11.15-31H396v50.29l-13.33.12V358.63l-12.59,34.43H357.91l-12.85-34.54v34.54H331.52",
    transform: "translate(-216 -306)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.53f50b379cf4764e948b7142f0bc2edf.svg";
export { ForwardRef as ReactComponent };